<template>
  <div class="header" :class="{'white-background':layoutHeaderProps.backgroundWhite}" @click="onGoIdx">
    <img :src="layoutHeaderProps.logo"/>
  </div>
</template>

<script lang="ts" setup>
import { Page } from '@/router/router-enum';


interface LoginHeaderProps {
  logo: string,
  backgroundWhite?: boolean,
}
const router = useRouter()
const onGoIdx = () => { 
  router.push(Page.LOGIN)
}
const layoutHeaderProps = withDefaults(defineProps<LoginHeaderProps>(), {
  backgroundWhite: false
})
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 60px;
  width: 100%;
  cursor: pointer;
  user-select: none;
  //background: #fafcff;
  //box-shadow: 0 3px 12px 0 rgba(194, 194, 194, 0.18);

  img {
    cursor: pointer;
    margin-left: 37px;
  }
}

.white-background {
  //background: #FFFFFF;
}
</style>
